import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { makeStyles, Theme } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import { colors } from '@lifesize/clients.mui-components';
import { hooks } from '@lifesize/clients.sdk';
import { ReactComponent as PersonPlusIcon } from '@lifesize/ux-assets/vectors/svgIcons/person-plus.svg';
import actions from 'actions/InCall/InCallDrawer';
import { ADD_PARTICIPANT_DRAWER } from 'constants/AddParticipantDrawer';
import LockedMeetingTooltip from 'components/Tooltip/LockedMeetingTooltip';

export const AddParticipantButton = () => {
  const classes = useStyles({});
  const isMeetingLocked = hooks.useIsWaitingRoomEnabled();
  const isModerator = hooks.useIsCurrentUserModerator();
  const isLockedByModerator = isMeetingLocked && !isModerator;
  const dispatch = useDispatch();

  const handleAddParticipantClicked = () => {
    dispatch(actions.openInCallDrawer(ADD_PARTICIPANT_DRAWER))
  };

  return (
    <button
      className={classes.button}
      data-testid="btnAddParticipant"
      disabled={isLockedByModerator}
      onClick={handleAddParticipantClicked}
    >
      {isLockedByModerator && <LockedMeetingTooltip />}
      <PersonPlusIcon data-testid="personPlusIcon" />
      <span>
        <FormattedMessage
          id="components.inCall.addPart"
          defaultMessage="Add a Participant"
        />
      </span>
    </button>
  )
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    alignItems: 'center',
    borderWidth: '1px 0 0!important',
    borderColor: `${colors.neutralGray}!important`,
    borderStyle: 'solid!important',
    border: 0,
    display: 'flex',
    flexDirection: 'row',
    fontSize: '1em',
    justifyContent: 'flex-start',
    minHeight: 38,
    outline: 0,
    padding: `${theme.spacing(0.75)}px ${theme.spacing(3)}px`,
    position: 'relative',
    width: '100%',

    '& svg': {
      color: colors.lifesize,
      flex: '0 0 auto',
      height: '2.6em',
      marginRight: theme.spacing(2)
    },
    '& > span': {
      color:colors.charcoal,
      fontSize: '1.4em',
      fontWeight: 'bold',
      textAlign: 'left'
    },
    '&:hover:not(:disabled)': {
      backgroundColor: fade(colors.lifesize, 0.2)
    },
    '&:disabled': {
      cursor: 'default',
        '& svg': {
        color: fade(colors.lifesize, 0.5)
      },
      '& > span': {
        color: fade(colors.charcoal, 0.5)
      }
    }
  }
}));

export default AddParticipantButton;
